import React from 'react';
import { useEffect, useState } from 'react';
import { api } from 'utils';

import { LogoWrapper } from './logo.styled';

const Logo = props => {
    const [logoSrcDark, setLogoSrcDark] = useState("");
    const [logoSrcLight /*, setlogoSrcLigth*/] = useState("logo-santillana-branco.png");
    const [onetime, setOneTime] = useState(false);
    const lightTheme = props.lightTheme;
    let logoSrc;

    useEffect(() => {
        async function getLogo() {
            const response = await api.get('/wp/v2/media', {
                params: { parent: 159, per_page: 2, order: 'desc', orderby: 'id', _fields: 'id,source_url' }
            });
            setLogoSrcDark(response.data[0].source_url);
        }

        if (!onetime) {
            getLogo();
            setOneTime(true);
        }
    }, [onetime]);

    function checkStatus() {
        if (lightTheme.includes('no-scrolled') & lightTheme.includes('white_header')) {
            logoSrc = logoSrcLight;
            return;
        }
        logoSrc = logoSrcDark;
    }

    checkStatus();

    return <LogoWrapper className="LogoWrapper">
        <a href='/'>
            <img className="logo" src={logoSrc} alt="Logo Santillana" />
            <img className="logominor" src={logoSrcDark} alt="Logo Santillana" />
        </a>
    </LogoWrapper>

}
export default Logo;